import { Component, Input, OnInit, forwardRef } from '@angular/core';

import { ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

interface DatetimeConfig {
  dateLabel?: string;
  timeLabel?: string;
}

@Component({
  selector: 'app-datetime',
  templateUrl: './datetime.component.html',
  styleUrls: ['./datetime.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatDatepickerModule,
    MatTimepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule
],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatetimeComponent),
      multi: true
    }
  ]
})

export class DatetimeComponent implements OnInit, ControlValueAccessor {
  @Input() label = 'Date';
  @Input() config: DatetimeConfig = {};
  
  // The internal data model
  private _value: Date | null = null;
  
  // ControlValueAccessor callbacks
  private onChange: (value: Date | null) => void = () => {};
  private onTouched: () => void = () => {};

  constructor() {}

  ngOnInit(): void {}
  
  get value(): Date | null {
    return this._value;
  }
  
  set value(val: Date | null) {
    // Only update if value really changed
    if (val !== this._value) {
      this._value = val;
      this.onChange(val);
    }
  }
  
  // Method called when input loses focus
  onBlur() {
    this.onTouched();
  }

  // ControlValueAccessor methods
  writeValue(value: Date | null): void {
    if (value !== this._value) {
      this._value = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

}
